export const ONE_SECOND = 1000
export const ONE_MINUTE = 60 * ONE_SECOND
export const DEFAULT_ZEROWIDTH = 50
export const PIXEL_PER_SECOND = 20
